import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
    maininput = "maininput"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
        [fields.maininput]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    modelName: state.components.contactUsForm.fieldValues["modelName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ModelNameStyles {
    modelNameTextField?: TextFieldPresentationProps;
    maininput?: InjectableCss;
}

export const modelNameStyles: ModelNameStyles = {
    maininput: {
        css: css`
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     [class^="FormFieldStyle"]{
                     display: inline;
            }  
                `,
                ])} 
        `
    },
    modelNameTextField: {
        css: css`
          ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     width: 55% !important;
                     float: right;
                `,
                ])} 
       
        `,
        labelProps: {
            css: css`
               ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        null,
                        css`
                     width: 40% !important;
                     float: left;
                     margin-top: 5px;
                `,
                    ])} 
            `
        },
    },
}
const styles = modelNameStyles;

const ModelName: React.FC<Props> = ({ fields, modelName, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [modelNameErrorMessage, setModelNameErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.modelName = validateModelName;
        if (typeof modelName !== "undefined") {
            validateModelName();
        }
    }, [modelName]);

    React.useEffect(() => {
        contactFormContext.validators.modelName = validateModelName;
    }, [isRequired]);

    const validateModelName = () => {
        const errorMessage = isRequired && !modelName ? (siteMessage("Field_Required", label) as string) : "";
        setModelNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const modelNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "modelName", value: event.target.value });
    };

    return (
        <>
            <StyledWrapper {...styles.maininput}>
                <TextField
                    {...styles.modelNameTextField}
                    label={label}
                    required={isRequired}
                    // placeholder={hintText}
                    value={modelName || ""}
                    error={modelNameErrorMessage}
                    onChange={modelNameChangeHandler}
                />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ModelName),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Model Or Series",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
